import styled from 'styled-components';

import { colors } from 'constants/colors';

import { WarehouseDeliveryFragmentFragment } from 'data/__generated__';

import { dateFromString, formatDateForDisplay } from '../../../../helpers/dateTimes';

export const PageHeader = ({ warehouseDelivery }: { warehouseDelivery: WarehouseDeliveryFragmentFragment }) => {
    const { deliveryDate, site, warehouseColumn } = warehouseDelivery;

    const deliveryDateObj = dateFromString(deliveryDate);

    return (
        <OuterContainer>
            <Content>
                <DetailsTable>
                    <thead>
                        <tr>
                            <HeaderCell>TOTEM SAS</HeaderCell>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <BodyCell>Société par actions simplifiée</BodyCell>
                        </tr>
                        <tr>
                            <BodyCell>Au capital de 723,10 euros</BodyCell>
                        </tr>
                        <tr>
                            <BodyCell>Siège social : 5 avenue du Général de Gaulle, 94160 Saint-Mandé</BodyCell>
                        </tr>
                        <tr>
                            <BodyCell>825 323 496 R.C.S. Créteil</BodyCell>
                        </tr>
                    </tbody>
                </DetailsTable>
                <DetailsTable>
                    <thead>
                        <tr>
                            <HeaderCell>LIVRAISON ENTREPÔT</HeaderCell>
                            <HeaderCell>
                                {site.organizationName ? `${site.organizationName} - ` : ''}
                                {site.name}
                            </HeaderCell>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <BodyCell $isBold>Date de livraison</BodyCell>
                            <BodyCell>
                                {deliveryDateObj ? formatDateForDisplay(deliveryDateObj) : deliveryDate}
                            </BodyCell>
                        </tr>
                        <tr>
                            <BodyCell $isBold>Site de destination</BodyCell>
                            <BodyCell>{site.name}</BodyCell>
                        </tr>
                        <tr>
                            <BodyCell $isBold>Entrepôt d'origine</BodyCell>
                            <BodyCell>{warehouseColumn.name}</BodyCell>
                        </tr>
                        {warehouseDelivery.operatorName && (
                            <tr>
                                <BodyCell $isBold>Opérateur</BodyCell>
                                <BodyCell>{warehouseDelivery.operatorName}</BodyCell>
                            </tr>
                        )}
                    </tbody>
                </DetailsTable>
            </Content>
            <TitleContainer>
                <Title>Bon de livraison</Title>
            </TitleContainer>
        </OuterContainer>
    );
};

const OuterContainer = styled.div`
    display: table-header-group;
`;

const Content = styled.div`
    display: flex;
    justify-content: space-between;
    color: ${colors.black};
`;

const DetailsTable = styled.table`
    border: 1px solid ${colors.lightGrey};
    padding: 5px;

    & > :not(:first-child) {
        margin-top: 5px;
    }
`;

const HeaderCell = styled.th`
    font-size: 14px;
    text-align: left;
`;

const BodyCell = styled.td<{ $isBold?: boolean }>`
    font-size: 12px;
    font-weight: ${({ $isBold }) => ($isBold ? 800 : 500)};
`;

const TitleContainer = styled.div`
    display: flex;
    justify-content: center;
    padding: 10px;
    font-weight: 800;
`;

const Title = styled.span`
    font-size: 32px;
    color: ${colors.green};
`;
